const data = (collection, keyword, filterType, filterEnterprise) => {
  if (!collection) {
    return [];
  }

  const searchWord = keyword.toLowerCase();

  const filterEnterpriseInt = filterEnterprise ? parseInt(filterEnterprise.value, 10) : null;

  return Object.values(collection).filter((item) => {
    const enterpriseId = item.attributes.enterprise_id;
    const title = item.attributes.title.toLowerCase();
    const { type } = item.attributes;

    let available = false;
    if (
      (filterEnterprise === null || filterEnterpriseInt === enterpriseId)
      && title.includes(searchWord)
      && (filterType === null || (filterType.value === type))
    ) {
      available = true;
    }

    return available;
  });
};

export default data;
